'use strict';
define('elements/map',['jquery'], function($, undefined) {
    $(function() {
        var $trigger = $('.map area'),
            $overlay = $('.map__overlay');

        $trigger.each(function(){
            var triggerId = $(this).attr('href'),
                handle = $(this).attr('alt');

            if($(this).hasClass('map--external')) {

            } else {
                $(this).click(function () {
                    var $target = $(triggerId),
                        $scrollTarget = $(triggerId + '+ .plate__title'),
                        targetOffset = $scrollTarget.offset();
                    $target.trigger('click');

                    $('body, html').animate({
                        scrollTop: targetOffset.top
                    }, 800);
                });
            }
            $(this).mouseenter(function(){
                $overlay.addClass(handle);
            });

            $(this).mouseleave(function(){
                $overlay.removeClass(handle);
            });
        });
    });
});

